var quotes = [
  'At last we will reveal ourselves to the Jedi. At last we will have revenge.',
  'Do not defy the council, Master, not again.',
  'Compassion, which I would define as unconditional love, is essential...',
  'Governor Tarkin. I should have expected to find you holding Vader\'s leash. I recognized your foul stench when I was brought onboard.',
  'These aren\'t the droids you\'re looking for.',
  'Remember... the Force will be with you, always.',
  'Be mindful of your thoughts Anakin. They\'ll betray you.',
  'Princess, we\'ll find Han. I promise.',
  'There\'s always a bigger fish.',
  'I\'m just a simple man trying to make my way in the universe.',
  'I\'ve been waiting for you, Obi-Wan. We meet again, at last. The circle is now complete.',
  'Sir, the possibility of successfully navigating an asteroid field is approximately 3,720 to 1.',
  'Obi-Wan Kenobi. Obi-Wan. Now that\'s a name I have not heard in a long time. A long time.',
  'Search your feelings, you know it to be true.',
  'Wait. I know that laugh...',
  'The force is with you, young Skywalker, but you are not a Jedi yet.',
  'Luke, we\'re gonna have company!',
  'Told you I did. Reckless is he. ...Now, matters are worse.',
  'Sometimes there are things no one can fix.',
  'A young Jedi named Darth Vader, who was a pupil of mine until he turned to evil, helped the Empire hunt down and destroy the Jedi knights.',
  'I thought they smelled bad on the outside!',
  'Obi-Wan has taught you well.',
  'Now, young Skywalker... you will die.',
  'Do what must be done.',
  'You cannot hide forever.',
  'You are a part of the Rebel Alliance and a traitor! Take her away!',
  'A Jedi\'s strength flows from the force.',
  'R2-D2, it is you, It is you!',
  'I sense great fear in you, Skywalker. You have hate... you have anger... but you don\'t use them.',
  'I can save him. I can turn him back to the good side. I have to try.',
  'Attacking that battle station is not my idea of courage. It\'s more like, suicide.',
  'Oh no, young Jedi. You will find that it is you who are mistaken - about a great many things.',
  'Did you hear that? They shut down the main reactor. We\'ll be destroyed for sure. This is madness.',
  'I do believe they think I am some kind of god.',
  'Luke, when gone am I... the last of the Jedi will you be.',
  'Twice the pride, double the fall.',
  'I will come back and free you, Mom. I promise.',
  'Down here, I am. Find a ladder, I must!',
  'Don\'t call me a mindless philosopher, you overweight glob of grease.',
  'You were the chosen one! It was said that you would destroy the Sith, not join them.',
  'Just being around her again is... intoxicating.',
  'All mentors have a way of seeing more of our faults than we would like. It\'s the only way we grow.',
  'Into the garbage chute, flyboy!',
  'Our fate is in your hands.',
  'Midi-chlorians are a microscopic life form that resides within all living cells.',
  'Would it help if I got out and pushed?',
  'I\'m a member of the Imperial Senate on a diplomatic mission to Alderaan.',
  'I\'m terribly sorry about all this. After all, he\'s only a Wookiee.',
  'You may have been a good smuggler, but now you\'re Bantha fodder.',
  'You were right about me. Tell your sister... you were right.',
  'Commander, tear this ship apart until you\'ve found those plans. And bring me the passengers, I want them alive!',
  'I have failed you Anakin. I have failed you.',
  'The Jedi are selfless, they only care about others.',
  'How wude.',
  'That is the sound of a thousand terrible things headed this way.',
  'Don\'t be too proud of this technological terror you\'ve constructed.',
  'You were right about one thing, Master. The negotiations were short.',
  'I know.',
  'It\'s against my programming to impersonate a deity.',
  'You still have much to learn, my young padawan.',
  'The force surrounds us and penetrates us. It binds the galaxy together.',
  'Train yourself to let go of everything you fear to lose.',
  'That\'s a good story. I think you just can\'t bear to let a gorgeous guy like me out of your sight.',
  'This bounty hunter is my kind of scum. Fearless and inventive.',
  'Use the Force, Luke.',
  'There is good in him. I\'ve felt it.',
  'Jedi Masters don\'t go crazy, they just get eccentric.',
  'Right now I feel like I could take on the whole Empire myself.',
  'The Sith rely on their passion for their strength. They think inward, only about themselves.',
  'Boring conversation anyway.',
  'No one can kill a Jedi.',
  'No more training do you require. Already know you that which you need.',
  'Well, short help is better than no help at all.',
  'I truly... deeply... love you and before we die I want you to know.',
  'Soon will I rest, yes, forever sleep. Earned it I have. Twilight is upon me, soon night must fall.',
  'You fool! I have been trained in your Jedi arts by Count Dooku.',
  'Oh, Han, it\'s not like that at all. He\'s my brother.',
  'Love won\'t save you, Padme. Only my new powers can do that.',
  'He will not let me down. He never has.',
  'This is some rescue. You came in here and you didn\'t have a plan for getting out?',
  'A Long Time Ago In A Galaxy Far Far Away...',
  'Droids don\'t pull people\'s arms outta their sockets when they lose... Wookies are known to do that...',
  'Why you stuck-up, half-witted, scruffy-looking nerf-herder!',
  'I suggest a new strategy, R2. Let the wookiee win.',
  'Don\'t make me destroy you.',
  'One thing\'s for sure, we\'re all going to be a lot thinner.',
  'I\'ve got a very bad feeling about this.',
  'R2-D2, you know better than to trust a strange computer!',
  'General Grievous, you\'re shorter than I expected.',
  'There\'s nothing for me here now. I want to learn the ways of the Force and be a Jedi, like my father before me.',
  'It\'s a trap!',
  'If there\'s a bright centre to the universe, you\'re on the planet that it\'s farthest from.',
  'Greed can be a very powerful ally.',
  'We seem to be made to suffer. It\'s our lot in life.',
  'Your thoughts betray you father. I feel the good in you. The conflict.',
  'Anakin, you\'re breaking my heart! And you\'re going down a path I cannot follow!',
  'Just for once, let me look on you with my own eyes.',
  'Clear your mind must be, if you are to discover the real villains behind this plot.',
  'Listen to them, they\'re dying, R2. Curse my metal body. I wasn\'t fast enough. It\'s all my fault. My poor master.',
  'Look, Your Worshipfulness, let\'s get one thing straight... I take orders from one person! Me!',
  'I can\'t do it, R2. I can\'t go on alone.',
  'Sometimes we must do what is requested of us.',
  'So this is how liberty dies, with thunderous applause.',
  'Look, good against remotes is one thing, good against the living, that\'s something else.',
  'Luke, I don\'t want to lose you to the Emperor the way I lost Vader.',
  'The Force runs strong in my family. My father has it. I have it. And... my sister has it. Yes. It\'s you, Leia.',
  'Fear is the path to the dark side. Fear leads to anger. Anger leads to hate. Hate leads to suffering.',
  'You are unwise to lower your defenses...',
  'I sense something; a presence I\'ve not felt since...',
  'Beware of the dark side.',
  'Ready are you? What know you of ready? For eight hundred years have I trained Jedi. My own counsel will I keep on who is to be trained.',
  'Don\'t center on your anxieties, Obi-Wan.',
  'Pain, suffering, death I feel. Something terrible has happened. Young Skywalker is in pain. Terrible pain.',
  'Only a master of evil, Darth.',
  'Everything is proceeding as I have foreseen.',
  'You don\'t know how hard I found it, signing the order to terminate your life.',
  'Dreams pass in time.',
  'This party\'s over.',
  'He\'s holding a thermal detonator!',
  'Are you an angel? I\'ve heard the deep space pilots talk about them. They\'re the most beautiful creatures in the universe.',
  'You refer to the prophecy of The One, who will bring balance to the Force. You believe it\'s this boy?',
  'Scoundrel? Scoundrel? I like the sound of that.',
  'In time, you will learn to trust your feelings. Then, you will be invincible.',
  'Without the midi-chlorians, life could not exist, and we would have no knowledge of the Force.',
  'There\'s no mystical energy field that controls my destiny.',
  'You must repair him! Sir, if any of my circuits or gears will help, I\'ll gladly donate them.',
  'Size matters not. Look at me. Judge me by my size, do you? Hmm? Hmm.',
  'All who gain power are afraid to lose it.',
  'Patience, my blue friend.',
  'I can only protect you, I cannot fight a war for you.',
  'Lando\'s not a system he\'s a man!',
  'I don\'t want to hear anymore about Obi-Wan. The Jedi turned against me! Don\'t you turn against me!',
  'You must feel the force around you. Here, between you, me, the tree, the rock... everywhere! Yes, even between this land and that ship!',
  'If so powerful you are, why leave?',
  'It is possible that the war itself has been only one further move in some greater game.',
  'Do not assume anything. Clear, your mind must be.',
  'Great, kid! Don\'t get cocky.',
  'You can\'t win. But there are alternatives to fighting.',
  'Difficult to see. Always in motion is the future.',
  'Good Anakin. Good. Kill him. Kill him now.',
  'Anger, fear, aggression; the dark side of the Force are they. Easily they flow, quick to join you in a fight.',
  'Luke, you can destroy the Emperor. He has foreseen this. It is your destiny. Join me, and together we can rule the galaxy as father and son.',
  'I\'m not afraid to die.',
  'Mudhole? Slimy? My home this is!',
  'You look absolutely beautiful. You truly belong here with us among the clouds.',
  'Either shut him up or shut him down!',
  'Oh my. Space travel sound rather perilous. I can assure you they will never get me on one of those dreadful Star Ships.',
  'I\'m Luke Skywalker, I\'m here to rescue you.',
  'Your overconfidence is your weakness.',
  'Anger, fear, aggression... the dark side are they. Once you start down the dark path, forever will it dominate your destiny.',
  'Every generation has a legend. Every journey has a first step. Every saga has a beginning.',
  'Always two there are, no more, no less: a master and an apprentice.',
  'Victory? Victory, you say? Master Obi-Wan, not victory. The shroud of the Dark Side has fallen. Begun, the Clone War has!',
  'Uh, we had a slight weapons malfunction, but uh, everything\'s perfectly all right now.',
  'That boy is our last hope.',
  'Luminous beings are we. Not this crude matter.',
  'Oh, my! What have you done? I\'m BACKWARDS. You flea-bitten furball! Only an overgrown mop-head like you would be stupid enough to...',
  'Luke... Luke... do not... do not underestimate the powers of the Emperor or suffer your father\'s fate you will.',
  'The ability to speak does not make you intelligent.',
  'He was meant to root out the Rebels, not give them hope. His sacrifice will only inspire them...',
  'You have your moments. Not many of them, but you do have them.',
  'The council has granted me permission to train you. You will be a Jedi, I promise.',
  'For over a thousand generations, the Jedi Knights were the guardians of peace and justice in the Old Republic.',
  'Ex-squeeze me, but the mostest safest place would be Gunga City.',
  'Boy, it\'s lucky you have these compartments!',
  'The drums of conflict are my beating heart.',
  'I find your lack of faith disturbing.',
  'That\'s your uncle talking.',
  'The Force is strong with him. The son of Skywalker must not become a Jedi.',
  'I can hold it... I can hold it... I CAN\'T HOLD IT!',
  'In his belly you will find a new definition of pain and suffering as you are slowly digested over a thousand years.',
  'Then I\'ll see you in hell!',
  'He is as clumsy as he is stupid. General, prepare your troops for a surface attack.',
  'Pass on what you have learned.',
  'From the moment I met you, all those years ago, not a day has gone by when I haven\'t thought of you.',
  'Look, I ain\'t in this for your revolution, and I\'m not in it for you, Princess. I expect to be well paid. I\'m in it for the money.',
  'Luke, you switched off your targeting computer - what\'s wrong?',
  'Will someone get this big walking carpet out of my way?',
  'Mom, you said that the biggest problem in the universe is no one helps each other.',
  'Your eyes can deceive you; don\'t trust them.',
  'Uh, uh... negative, negative. We had a reactor leak here now. Give us a few minutes to lock it down. Large leak, very dangerous.',
  'Hmph. Adventure. Heh. Excitement. Heh. A Jedi craves not these things. You are reckless.',
  'You may dispense with the pleasantries, Commander. I am here to put you back on schedule.',
  'Master Kenobi, you disappoint me. Yoda holds you in such high esteem. Surely you can do better!',
  'He\'s quite clever, you know... for a human being.',
  'This is Red 5, I\'m going in.',
  'Because you are my Son!',
  'I haven\'t gone by the name of Obi-Wan since... oh, before you were born.',
  'He will join us or die, my master.',
  'I think I\'m finally getting the hang of this flying business.',
  'Never tell me the odds.',
  'And I am C-3PO, human-cyborg relations. And this is my counterpart R2D2.',
  'She may not look like much, but she\'s got it where it counts, kid.',
  'Jedi business. Go back to your drinks.',
  'It\'s not wise to upset a Wookiee.',
  'I don\'t know who you are or where you\'ve come from, but from now on you\'ll do as I say, okay?',
  'How you doin\' Chewbacca? Still hanging around with this loser?',
  'Some day you\'re gonna be wrong, I just hope I\'m there to see it.',
  'The ability to destroy a planet is insignificant next to the power of the Force.',
  'Crush them! Make them suffer!',
  'Use my knowledge, I beg you.',
  'I felt a great disturbance in the force, as if millions of voices suddenly cried out in terror and were suddenly silenced.',
  'Anakin, please tell me this isn\'t another of your patented rescues where we\'ll require the whole Republic army to get safely away.',
  'I have you now!',
  'But which one was destroyed? The master or the apprentice?',
  'I don\'t believe what I\'m hearing... Obi-Wan was right. You\'ve changed.',
  'Always on the move.',
  'The Dark Side of the Force is the pathway to many abilities some consider to be... Unnatural.',
  'When 900 years old, you reach... Look as good, you will not.',
  'You were my brother, Anakin. I loved you.',
  'Army or not. You must realize, you are doomed.',
  'Hold your fire. There\'s no life forms. It must have short-circuited.',
  'Captain, being held by you isn\'t quite enough to get me excited.',
  'You can forget your troubles with those Imperial slugs. I told you I\'d outrun \'em. Don\'t everyone thank me at once.',
  'You can\'t win, Darth. Strike me down, and I will become more powerful than you could possibly imagine.',
  'You\'ll be dead!',
  'Nooooooooooooooooooo!',
  'Attachment is forbidden. Possession is forbidden. Compassion, which I would define as unconditional love, is essential to a Jedi\'s life.',
  'I sense a great deal of confusion in you, young Skywalker. There\'s much fear that clouds your judgement.',
  'Keep your concentration here and now, where it belongs.',
  'Into exile I must go, failed I have.',
  'Watch your mouth kid, or you\'ll find yourself floating home.',
  'Aren\'t you a little short for a stormtrooper?',
  'Truly wonderful, the mind of a child is.',
  'Laugh it up, Fuzz ball.',
  'Promise. Promise me you will train the boy. He... is the chosen one... he will bring balance. Train him.',
  'Impressive, most impressive.',
  'Oh my goodness, shut me down! Machines making machines. How perverse.',
  'I\'m Luke Skywalker. I\'m here to rescue you.',
  'Keep your distance, Chewie, but don\'t, y\'know, look like you\'re keeping your distance.',
  'Don\'t get technical with me. What mission? What are you talking about? I\'ve just about had enough of you. Go that way, you\'ll be malfunctioning in a day you near-sighted scrap pile.',
  'I have waited a long time for this moment, my little green friend. At last, the Jedi are no more.',
  'Blind we are, if creation of this clone army we could not see.',
  'Asteroids do not concern me, Admiral. I want that ship, not excuses.',
  'A tremor in the Force. The last time I felt it was in the presence of my old master.',
  'Bargain rather than fight? He\'s no Jedi.',
  'The Force can have a strong influence on the weak-minded.',
  'Aaaaaaargh!',
  'Now, be brave and don\'t look back. Don\'t look back.',
  'Patience, use the Force, think!',
  'I don\'t like you either. You just watch yourself. We\'re wanted men. I have the death sentence on twelve systems.',
  'The Jedi are extinct, their fire has gone out of the universe. You, my friend, are all that\'s left of their religion.',
  'I hope so Commander, for your sake. The Emperor is not as forgiving as I am.',
  'What a piece of junk!',
  'I\'m getting too old for this sort of thing.',
  'You fool! I\'ve been trained in your Jedi arts by Count Dooku.',
  'Make, at least, 20 people smile in a day.',
  'Mmm. Lost a planet, Master Obi-Wan has. How embarrassing.',
  'Bring \'em on, I\'d prefer a straight fight to all this sneaking around.',
  'In my experience, there\'s no such thing as luck.',
  'I guess you don\'t know everything about women yet.',
  'Evacuate in our moment of triumph? I think you overestimate their chances.',
  'To a dark place this line of thought will carry us. Great care we must take.',
  'All his life has he looked away... to the future, to the horizon. Never his mind on where he was. Hmm? What he was doing.',
  'I was not elected to watch my people suffer and die while you discuss this invasion in a committee!',
  'Wonderful girl. Either I\'m going to kill her or I\'m beginning to like her.',
  'Why do I sense we\'ve picked up another pathetic life-form?',
  'These blast points - too accurate for sandpeople. Only imperial stormtroopers are so precise.',
  'How ya feeling kid? You don\'t look so bad to me. You look strong enough to pull the ears off a gundark.',
  'No, my father didn\'t fight in the Clone Wars. He was a navigator on a spice freighter.',
  'You were to bring balance to the force, not leave it in darkness.',
  'Mesa called JaJa Binks, mesa youse humble servant!',
  'A Jedi uses the force for knowledge and defense, never for attack.',
  'I don\'t like sand. It\'s coarse and rough and irritating and it gets everywhere. Not like here. Here everything is soft and smooth.',
  'Me? A Master? I\'m overwhelmed, sir. But the Council elects its own members. They will never accept this.',
  'One truth, one hate.',
  'Thank the maker!',
  'Many Bothans died to bring us this information.',
  'Help me Obi-Wan Kenobi, you\'re my only hope.',
  'The Force is what gives a Jedi his power. It\'s an energy field created by all living things. It surrounds us and penetrates us. It binds the galaxy together.',
  'If you have warriors, now is the time.',
  'This will be a day long remembered. It has seen the end of Kenobi, and will soon see the end of the rebellion.',
  'I recognized your foul stench when I was brought on board.',
  'You\'ve never heard of the Millennium Falcon?... It\'s the ship that made the Kessel run in less than 12 parsecs.',
  'Son, my place is here, my future is here. It is time for you to let go.',
  'We are indebted to you for your bravery, Obi-Wan Kenobi. And you, young Skywalker; we will watch your career with great interest.',
  'I\'m altering the deal. Pray I don\'t alter it any further.',
  'To be angry is to be human.',
  'You came in that thing? You\'re braver than I thought.',
  'Attachment leads to jealousy. The shadow of greed that is.',
  'You know better than to trust a strange computer.',
  'Someday I\'ll be the most powerful Jedi ever.',
  'You were the Chosen one!',
  'Traveling through hyperspace ain\'t like dusting crops, farm boy.',
  'You can either profit by this or be destroyed. It\'s your choice, but I warn you not to underestimate my power.',
  'R2, why did you have to be so brave?',
  'Jabba, you\'re a wonderful human being.',
  'All who gain power are afraid to lose it.',
  'Help me Obi-Wan Kenobi. You\'re my only hope.',
  'You\'re asking me to be rational. That is something I know I cannot do. Believe me, I wish I could just wish away my feelings, but I can\'t.',
  'What if the democracy we thought we were serving no longer exists, and the Republic has become the very evil we\'ve been fighting to destroy?',
  'Hello. I don\'t believe we have been introduced. R2-D2? A pleasure to meet you. I am C-3PO, Human-Cyborg Relations.',
  'Faith in your new apprentice, misplaced may be. As is your faith in the dark side of the Force.',
  'Give yourself to the Dark Side. It is the only way you can save your friends. Yes your thoughts betray you.',
  'You must unlearn what you have learned.',
  'Now don\'t you forget this! Why I should stick my neck out for you is far beyond my capacity!',
  'Feel the Force!',
  'I am not training him.',
  'Something\'s happening. I\'m not the Jedi I should be. I want more. And I know I shouldn\'t.',
  'Feel, don\'t think.',
  'I\'ve been waiting for you, Obi-Wan. We meet again, at last. The circle is now complete. When I left you, I was but the learner; now I am the master.',
  'I will not condone a course of action that will lead us to war.',
  'At the thought of not being with you, I can\'t breathe.',
  'Don\'t try to frighten us with your sorcerous ways, Lord Vader.',
  'It is obvious that this contest cannot be decided by our knowledge of the Force... but by our skills with a lightsaber.',
  'Wipe them out. All of them.',
  'Look, sir: Droids.',
  'If you\'re not with me, then you\'re my enemy.',
  'May the force be with you.',
  'A Jedi Knight? Jeez, I\'m out of it for a little while, everyone gets delusions of grandeur!',
  'These Federation types are cowards. The negotiations will be short.',
  'Your powers are weak, old man.',
  'Through the force, things you will see. Other places. The future... the past. Old friends long gone.',
  'Hokey religions and ancient weapons are no match for a good blaster at your side, kid.',
  'Clear your mind of questions.',
  'Great shot kid, that was one in a million.',
  'Wars not make one great.',
  'Let the Wookie win.',
  'This is some rescue! You came in here, but didn\'t you have a plan for getting out?',
  'That... is why you fail.',
  'I don\'t sense anything.',
  'Mos Eisley spaceport. You will never find a more wretched hive of scum and villainy.',
  'Not to worry. We\'re still flying half a ship.',
  'Another happy landing.',
  'Rejoice for those around you who transform into the Force.',
  'The Force is strong with this one.',
  'I see you becoming the greatest of all the Jedi, Anakin. Even more powerful than Master Yoda.',
  'No. I am your Father.',
  'It is too late for me, son. The Emperor will show you the true nature of the Force. He is your master now.',
  'The Chancellor\'s right, Senator. We\'ll be quite safe. He won several cups for airspeeder racing back on Naboo.',
  'No! Try not. Do, or do not. There is no try.',
  'Anything is possible.',
  'Your arrogance blinds you.',
  'I\'m haunted by the kiss that you should never have given me. My heart is beating... hoping that kiss will not become a scar.',
  'Only a sith deals in absolutes.',
  'We live in a real world, Annie. Come back to it.',
  'So, what do you think? You think a princess and a guy like me...',
  'Don\'t center on your anxieties, Obi-Wan. Keep your concentration here and now, where it belongs.',
  'I\'ll be careful.',
  'Who\'s the more foolish: the fool, or the fool who follows him?',
  'General, prepare your men.',
  'The strong survive, the weak die. That\'s the way the galaxy works. The day we forgot that, we became everyone\'s lackey.',
  'We have powerful friends. You\'re going to regret this.',
  'I\'ve seen a lot of strange stuff, but I\'ve never seen anything to make me believe there\'s one all-powerful Force controlling everything.',
  'Maybe you\'d like it back in your cell, your highness.',
  'I want them alive - no disintegrations!',
  'A Jedi must have the deepest commitment, the most serious mind.',
  'I think my eyes are getting better. Instead of a big dark blur, I see a big light blur.',
  'We have a new enemy, the young Rebel who destroyed the Death Star. I have no doubt this boy is the offspring of Anakin Skywalker.',
  'Jabba\'s put a price on your head so large, every bounty hunter in the galaxy will be looking for you.',
  'My parts are showing? Oh, my goodness, oh!',
  'That\'s no moon, it\'s a space station.',
  'The Force is strong with you. A powerful Sith you will become. Henceforth, you shall be known as Darth... Vader.',
  'You slimy, double-crossing, no-good swindler. You\'ve got a lot of guts coming here, after what you pulled.',
  'Soon, I will have a new apprentice. One far younger, and more powerful.',
  'You\'re all clear, kid! Now let\'s blow this thing and go home!',
  'He\'s the brains, sweetheart!',
  'You will find that many of the truths we cling to depend greatly on our own point of view.',
  'I\'m a person, and my name is Anakin!',
  'This station is now the ultimate power in the universe! I suggest we use it.',
  'Hold me, like you did by the lake on Naboo; so long ago when there was nothing but our love. No politics, no plotting, no war.',
  'You can\'t stop the change any more than you can stop the suns from setting.',
  'Death is a natural part of life.'
];

module.exports = function() {
  return quotes[Math.floor(Math.random() * quotes.length)]
}

module.exports.quotes = quotes